/**
 * @file The Multi type fieldset component.
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FieldsetBase } from '../../base/fieldsets/fieldset-base/fieldset-base';
import { FieldsetProvider } from '../../base/fieldsets/fieldset-provider';
import { FormControl } from '@angular/forms';
import { ComponentRegistry } from '../../core/component-registry';
var FieldsetMultiTypeComponent = /** @class */ (function (_super) {
    tslib_1.__extends(FieldsetMultiTypeComponent, _super);
    /**
     * Constructs a FieldsetEntityComponent
     */
    function FieldsetMultiTypeComponent(provider) {
        var _this = _super.call(this, provider) || this;
        _this.sourceTypeValue = undefined;
        _this.lastEntity = null;
        _this.sourceTypeControl = new FormControl();
        _this.sourceTypes = [];
        _this.sources = {};
        return _this;
    }
    Object.defineProperty(FieldsetMultiTypeComponent.prototype, "sourceType", {
        get: function () {
            var entity = this.provider.value;
            if (entity !== this.lastEntity) {
                this.lastEntity = entity;
                if (entity) {
                    this.sourceTypeValue = entity.entityType.shortName;
                    return this.sourceTypeValue;
                }
                if (!this.sourceTypeValue) {
                    if (this.sourceTypes.length > 0) {
                        this.sourceTypeValue = this.sourceTypes[0].value;
                        return this.sourceTypeValue;
                    }
                }
            }
            return this.sourceTypeValue;
        },
        set: function (value) {
            if (this.sourceTypeValue === value) {
                return;
            }
            this.sourceTypeValue = value;
            this.provider.value = null;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Register component by the fieldset provider
     */
    FieldsetMultiTypeComponent.register = function () {
        ComponentRegistry.register('fieldset', 'multitype', FieldsetMultiTypeComponent);
    };
    FieldsetMultiTypeComponent.prototype.ngOnInit = function () {
        var _this = this;
        var format = this.provider.field.format;
        Object.keys(format).forEach(function (sourceName) {
            var entityFormat = format[sourceName];
            _this.sourceTypes.push({
                labelKey: sourceName, value: entityFormat.entity
            });
            _this.sources[entityFormat.entity] = entityFormat;
        });
    };
    FieldsetMultiTypeComponent.prototype.sourceTypeSelected = function () {
        return this.sourceTypeValue && this.sourceTypeValue !== '';
    };
    return FieldsetMultiTypeComponent;
}(FieldsetBase));
export { FieldsetMultiTypeComponent };
